import type { Seg } from 'components/common/SchemaFormTemplates/referencePath';

// SchemaForm remounts its rjsf Form whenever the generated uiSchema changes, which
// would close an open transformation editor and lose its draft. Sessions are kept in a
// store SchemaForm owns (passed down in formContext), so they survive that remount and
// are dropped with the form itself.
export type EditorSession = {
  // The jq_filter the draft started from. A session whose base no longer matches the
  // field's value is stale (someone else saved meanwhile) and is discarded.
  base: string;
  draft: string;
  codeMode?: boolean;
  sampleKey?: string;
};

export type EditorSessionStore = Map<string, EditorSession>;

export const createEditorSessionStore = (): EditorSessionStore => new Map();

/** Identifies the endpoint by its data type rather than its array index, so a reordered
 *  list doesn't reopen a draft on another endpoint. The connector allows one endpoint per type. */
export function editorSessionKey(
  integrationId: string | undefined,
  idPrefix: string | undefined,
  fieldPath: Seg[],
  outputType: string,
): string {
  const path = fieldPath.filter((seg) => typeof seg !== 'number').join('.');
  return `${integrationId ?? 'draft'}|${idPrefix ?? 'root'}|${path}|${outputType}`;
}

/** The session for `key` if it still applies to `value`; a stale one is removed. */
export function liveEditorSession(
  store: EditorSessionStore,
  key: string,
  value: string,
): EditorSession | undefined {
  const session = store.get(key);
  if (session && session.base !== value) {
    store.delete(key);
    return undefined;
  }
  return session;
}
